// 메인 스레드(lib/push.ts)와 서비스워커(sw.ts) 양쪽에서 쓰이므로
// DOM/WebWorker 어느 쪽에도 의존하지 않는 순수 모듈로 유지한다.

export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  messagingSenderId: string;
  appId: string;
}

/**
 * `.env` 의 Firebase 웹 설정을 읽는다. 하나라도 비어 있으면 `null` 을 반환하고
 * 호출부는 푸시를 조용히 건너뛴다(조회 기능은 그대로 동작).
 */
export function readFirebaseConfig(): FirebaseWebConfig | null {
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  const complete = Object.values(config).every(
    (v) => typeof v === "string" && v.length > 0,
  );
  return complete ? (config as FirebaseWebConfig) : null;
}

/** 웹 푸시 인증키(VAPID). 없으면 토큰을 발급할 수 없다. */
export const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY ?? "";
